export enum GTMEvents {
  PRODUCT_ADDED = "Product Added",
  PRODUCT_REMOVED = "Product Removed",
  CART_VIEWED = "Cart Viewed",
  CHECKOUT_STARTED = "Checkout Started",
  PAYMENT_INFO_ENTERED = "Payment Info Entered",
  ORDER_COMPLETED = "Order Completed",
  COUPON_APPLIED = "Coupon Applied",
  CTA_CLICKED = "CTA Clicked",
}

export const gtmFeatureKey = "GOOGLE_TAG_MANAGER";
